import { Grid, TextField, Typography } from "@mui/material";
import ColumnContainer from "../../../../common/ColumnContainer";
import InfoModalComponent from "../../../../common/modals/InfoModalComponent";
import { useState } from "react";
import { SnackbarComponent } from "../../../../common/SnackbarComponent";
import { FormattedMessage } from "react-intl";

export const ManualVehicleInfoInsertionModal = ({
  openManualInfoModal,
  handleCloseManualInfoModal,
  formData,
  onPassManualInfo,
}) => {
  const [manualInfo, setManualInfo] = useState({
    type: "",
    brand: "",
    model: "",
    generation: "",
    engine: "",
    engine_hp: "",
    year: "",
    gearbox: "",
    fuel: "",
    ecu_brand: "",
    ecu_name: "",
    ecu_type: "",
  });
  const [openSnackbarEmptyFields, setOpenSnackbarEmptyFields] = useState(false);

  const handleManualInfoFieldChange = (value, key) => {
    setManualInfo((prevState) => {
      const updatedManualInfo = { ...prevState };
      updatedManualInfo[key] = value;
      return updatedManualInfo;
    });
  };

  const handleLiftUpManualInfo = () => {
    for (const [key, value] of Object.entries(manualInfo)) {
      if (key === "brand" || key === "model") {
        if (!value) {
          setOpenSnackbarEmptyFields(true);
          return;
        }
      }
    }

    setOpenSnackbarEmptyFields(false);
    onPassManualInfo(manualInfo);
    handleCloseManualInfoModal();
  };

  return (
    <InfoModalComponent
      className={[]}
      openModal={openManualInfoModal}
      handleCloseModal={handleCloseManualInfoModal}
      confirmButton={true}
      handleConfirm={() => handleLiftUpManualInfo()}
    >
      <ColumnContainer align="start" style={{ gap: "4rem" }}>
        <Typography variant="p" component="p" paddingLeft="8px">
          <FormattedMessage id="project.insert.vehicleInfo" />:
        </Typography>
        <Grid container spacing={3} rowSpacing={5} className="field-container">
          {formData?.map((item, index) => {
            return (
              <Grid item xs={12} md={6} sm={6} lg={4}>
                <TextField
                  size="small"
                  autoComplete="off"
                  required={item.name === "brand" || item.name === "model"}
                  fullWidth
                  label={item.label}
                  type={"text"}
                  name={item.name}
                  value={manualInfo[item.name]}
                  onChange={(e) =>
                    handleManualInfoFieldChange(e.target.value, item.name)
                  }
                />
              </Grid>
            );
          })}
        </Grid>
        <SnackbarComponent
          open={openSnackbarEmptyFields}
          duration={8000}
          handleClose={() => setOpenSnackbarEmptyFields(false)}
          message={<FormattedMessage id="snackbar.manual.vehicleInfo" />}
        />
      </ColumnContainer>
    </InfoModalComponent>
  );
};
